import { render, staticRenderFns } from "./emailForm.vue?vue&type=template&id=66e643d6"
import script from "./emailForm.vue?vue&type=script&lang=js"
export * from "./emailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports